import axios from '@/plugins/http.js'

export default class Time {
  get = async () => {
    try {
      const api = `/api/v1/time`
      const { data } = await axios.get(api)

      return data
    } catch (e) {
      console.error(e)
      return null
    }
  }
}
